<template>
  <DpplSkeletonLoader class="vertical-stacked-widget-skeleton">
    <div class="skeleton-body">
      <div class="chart-bars">
        <VerticalStackedBarsLargeSvg
          v-if="size === 'large'"
        />
        <VerticalStackedBarsSmallSvg
          v-else
        />
      </div>
      <div class="chart-axis">
        <v-skeleton-loader
          v-for="(_, k) in Array(arraySize)"
          :key="k"
          type="text"
          width="48px"
          height="17px"
        />
      </div>
    </div>
  </DpplSkeletonLoader>
</template>

<script>
import DpplSkeletonLoader from '@/components/datapeople/DpplSkeletonLoader.vue';
import VerticalStackedBarsLargeSvg from '@/assets/vertical-stacked-bar-large-widget-skeleton.svg?component';
import VerticalStackedBarsSmallSvg from '@/assets/vertical-stacked-bar-small-widget-skeleton.svg?component';

export default {
  name: 'VerticalStackeBarSkeleton',
  components: {
    VerticalStackedBarsLargeSvg,
    VerticalStackedBarsSmallSvg,
    DpplSkeletonLoader,
  },
  props: {
    size: {
      type: String,
      default: 'small',
    },
  },
  computed: {
    arraySize() {
      return this.size === 'small' ? 6 : 12;
    },
  },
};
</script>

<style scoped lang="less">
.vertical-stacked-widget-skeleton {
  height: 100%;
  width: 100%;
}

.skeleton-body {
  height: calc(100% - 17px);
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.chart-bars {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
}

.chart-axis {
  display: flex;
  justify-content: space-between;
}
</style>
